export const TRANSLATIONS = {
  de: {
    // PAGE META
    page_title: 'Wohnen am Waldrand – Exklusive Wohnungen & Ferienwohnungen in Oberbozen am Ritten | TRES IMMO',
    page_description: '11 exklusive Wohnungen und Ferienwohnungen in Oberbozen am Ritten, Südtirol. Naturnahes Wohnen am Waldrand mit Panoramablick auf die Dolomiten. Jetzt Traumwohnung sichern – TRES IMMO.',
    og_title: 'Wohnen am Waldrand – Exklusive Wohnungen in Oberbozen am Ritten',
    og_description: '11 exklusive Wohnungen und Ferienwohnungen in Oberbozen, Südtirol. Panoramablick, Waldnähe, KlimaHaus-Standard.',

    // HERO
    hero_location: 'Oberbozen · Ritten · Südtirol',
    hero_tagline: 'Wohnen am Waldrand',
    hero_sub: 'Oberbozen &nbsp;·&nbsp; Ritten &nbsp;·&nbsp; Südtirol',
    hero_scroll: 'Entdecken',
    hero_cta_units: 'Freie Einheiten',
    hero_cta_expose: 'Exposé anfordern',
    bf_banner_text: 'Baufortschritt: Die Decke über der Garage ist betoniert! Zum Bautagebuch →',
    form_newsletter_label: 'Ich möchte per E-Mail über den aktuellen Baufortschritt informiert werden (Bautagebuch).',
    urgency_only_few_left: 'Nur noch {count} freie Einheiten verfügbar!',

    // PROJEKT SECTION
    projekt_label: 'Das Projekt',
    projekt_headline: 'Dort wo der Wald<br />auf <em>Stille</em> trifft.',
    projekt_text: 'Mitten in Oberbozen auf dem Ritten entsteht eine exklusive Wohnanlage mit herrlichem Ausblick ins Bergpanorama. Naturbelassene Materialien, zeitlose Architektur und alpine Ruhe – geschaffen von einem jungen Bauträger-Team aus dem sonnigen Südtirol. Wer eine Wohnung kaufen in Oberbozen sucht, findet hier ein Projekt, das keine Wünsche offenlässt.',

    // CARDS
    card1_label: 'Exklusive Wohnungen',
    card1_desc: 'Von gemütlichen 2-Zimmer-Wohnungen bis hin zu großzügigen Penthouse-Einheiten.',
    card2_label: 'Meter über dem Meer',
    card2_desc: 'Wohnung kaufen am Ritten: Frische Bergluft, Waldnähe und Bergpanorama auf 1200m Höhe.',
    card3_label: 'Momente der Ruhe',
    card3_desc: 'Direkt am Waldrand, nahe der Natur. Nah bei allem, was zählt.',
    card4_desc: 'Frei von Bindungen – uneingeschränkt als Ferienwohnung nutzbar.',

    // RIMMO NOTE
    rimmo_text: 'Exklusivverkauf über <a class="rimmo-link" href="https://rimmo.it/" target="_blank" rel="noopener"><strong>Rimmo Immobilien</strong></a>',
    rimmo_wa_btn: 'Anfragen',

    // VISUALISIERUNGEN SECTION
    viz_label: 'Impressionen',
    viz_headline: 'Leben am <em>Höchsten</em> Niveau.',
    viz_caption1: 'Architektur',
    viz_caption2: 'Wohnkomfort',
    viz_caption3: 'Panoramablick',
    viz_caption4: 'Ferienwohnung I',
    viz_caption5: 'Ferienwohnung II',
    viz_caption6: 'Ferienwohnung III',
    viz_note: 'Beispielhafte Visualisierungen',

    // LAGE SECTION
    lage_label: 'Lage',
    lage_headline: 'Dem Himmel<br />so <em>nah</em>.',
    lage_item1_title: 'In 12 Minuten ins Zentrum',
    lage_item1_text: 'Entfliehen Sie dem Trubel und der Sommerhitze des Bozner Talkessels. Die Rittner Seilbahn bringt Sie in nur 12 Minuten von der Ruhe am Waldrand direkt in die Altstadt von Bozen.',
    lage_item2_title: 'Das Rittner Bahnl & Skigebiet',
    lage_item2_text: 'Die historische Schmalspurbahn verbindet Oberbozen mit Klobenstein. Von dort aus sind die Ski- und Wandergebiete rund um das Rittner Horn in greifbarer Nähe.',
    lage_item3_title: 'Naturidylle ab der Haustür',
    lage_item3_text: 'Direkt am Waldrand gelegen, beginnen Wander- und Spazierwege buchstäblich vor Ihrer Tür. Eine perfekte Balance aus Abgeschiedenheit und dörflicher Infrastruktur (Gastronomie, Apotheke, Supermarkt). Wohnung kaufen am Ritten – hier lebt man mit der Natur, nicht neben ihr.',

    // AUSSTATTUNG SECTION
    ausstattung_label: 'Qualität',
    ausstattung_headline: 'Ohne <em>Kompromisse</em>.',
    ausstattung_item1_title: 'KlimaHaus Standard',
    ausstattung_item1_text: 'Modernste Bauweise kombiniert mit einem ausgeklügelten Energiekonzept. Höchste Effizienz, niedrigste Energiekosten und nachhaltiger Wohnkomfort, der dem alpinen Klima Rechnung trägt.',
    ausstattung_item2_title: 'Panoramaterrassen & G\u00e4rten',
    ausstattung_item2_text: 'Weite, bodentiefe Fensterfronten öffnen den Wohnraum zur Natur. Großzügige Eigengärten im Erdgeschoss und großzügige Terrassen bei den Wohnungen laden zum Genießen des Bergpanoramas ein.',
    ausstattung_item3_title: 'Privatsph\u00e4re & Sicherheit',
    ausstattung_item3_text: 'Durchdachte Grundrisse, akustische Entkopplung und exklusive Materialwahl schaffen Rückzugsorte vollkommener Ruhe. Inklusive geschützter Tiefgaragenstellplätze für alle Einheiten.',

    // EINHEITEN SECTION
    einheiten_label: 'Projekt Waldrand',
    einheiten_headline: 'Verfügbare <em>Einheiten</em>',
    table_loading: 'Lade Einheiten...',
    table_col_unit: 'Einheit',
    table_col_unit_short: '#',
    table_col_floor: 'Etage',
    table_col_rooms: 'Zimmer',
    table_col_rooms_short: 'Z',
    table_col_area: 'Wohnfläche',
    table_col_area_short: 'm²',
    table_col_price: 'Preis',
    table_col_status: 'Status',
    table_no_units: 'Keine Einheiten gefunden.',
    table_load_error: 'Fehler beim Laden der Daten.',
    units_note: 'Alle Preise verstehen sich zzgl. MwSt. 4% für die Erstwohnung und 10% für die Zweitwohnung.',
    unit_on_request: 'Auf Anfrage',
    unit_details_link: 'Details',

    // SEO PARAGRAPH
    seo_text: 'Wohnung kaufen in Oberbozen – exklusives Wohnbauprojekt am Ritten, Südtirol. Nur 11 Einheiten, limitiert verfügbar.',

    // MODAL STATS LABELS
    modal_stat_floor: 'Etage',
    modal_stat_rooms: 'Zimmer',
    modal_stat_area: 'Fläche',
    modal_stat_price: 'Preis',
    modal_action_plan: 'Plan',
    modal_action_inquiry: 'Anfrage',
    modal_action_wa: 'WhatsApp',
    modal_action_share: 'Teilen',
    modal_expose: '📄 Exposé herunterladen',

    // COMING SOON / KONTAKT
    coming_label: 'Kontakt & Exposé',
    coming_headline: 'Jetzt exklusives <span class="cs-dot"></span><br /><em>Exposé</em> anfordern.',
    coming_text: 'Tragen Sie sich unverbindlich ein, um das detaillierte Exposé mit Grundrissen und Preisen zu erhalten und aktuelle Updates zum Baufortschritt zu bekommen.',
    form_name: 'Vor- und Nachname *',
    form_email: 'E-Mail Adresse *',
    form_phone: 'Telefonnummer',
    form_message: 'Ihre Nachricht (optional)',
    form_submit: 'Jetzt anfragen',
    form_sending: 'Wird gesendet...',
    recaptcha_text: 'Diese Seite ist durch reCAPTCHA geschützt. Es gelten die',
    recaptcha_privacy: 'Datenschutzerklärung',
    recaptcha_terms: 'Nutzungsbedingungen',
    recaptcha_of_google: 'von Google.',
    wa_or_via: 'Oder direkt via',
    wa_chat_btn: 'WhatsApp Chat',

    // FOOTER
    footer_logo_sub: 'Wohnen am Waldrand',
    footer_desc: 'Ein junges Bauträger- und Immobilienentwickler-Team aus dem sonnigen Südtirol. Mit Leidenschaft für Qualität und alpine Lebensqualität.',
    footer_contact_label: 'Kontakt',
    footer_wa_label: 'WhatsApp',
    footer_cta: 'Jetzt anfragen 🙋',
    footer_rights: '© TRES IMMO &nbsp;·&nbsp; Oberbozen, Ritten, Südtirol &nbsp;·&nbsp; Alle Rechte vorbehalten &nbsp;|&nbsp; <a href="#" onclick="openPrivacyModal(event)" style="color:inherit; text-decoration:underline;">Datenschutz &amp; Impressum</a>',

    // COOKIE BANNER
    cookie_header: 'Datenschutz & Cookies',
    cookie_text_short: 'Wir verwenden Cookies für den Betrieb und anonyme Statistiken. <a href="#" onclick="openPrivacyModal(event)">Mehr Infos</a>',
    cookie_text: 'Wir verwenden Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Dazu zählen Cookies, die für den Betrieb der Seite notwendig sind, sowie solche für anonyme Statistikzwecke oder die Einbindung externer Dienste (wie z.B. <strong>reCAPTCHA</strong> für unser Formular). Weitere Informationen finden Sie in unserer <a href="#" onclick="openPrivacyModal(event)">Datenschutzerklärung</a>.',
    cookie_essential: 'Nur Notwendige',
    cookie_accept: 'Alle Akzeptieren',

    // PRIVACY MODAL
    privacy_title: 'Datenschutz & Impressum',

    // JS STRINGS
    js_floor_basement: 'UG',
    js_floor_ground: 'EG',
    js_floor_upper: '. OG',
    js_rooms_suffix: ' Zi.',
    js_wa_greeting: 'Guten Tag, ich interessiere mich für Einheit \u201e',
    js_wa_project_in: '\u201c im Projekt \u201e',
    js_wa_project_close: '\u201c. Bitte senden Sie mir mehr Informationen zu.',
    js_email_subject_prefix: 'Anfrage ',
    js_email_subject_dash: ' \u2013 ',
    js_email_body_intro: 'Guten Tag,\n\nIch interessiere mich f\u00fcr Einheit ',
    js_email_body_in: ' im Projekt ',
    js_email_body_close: '.\nBitte senden Sie mir mehr Informationen zu.\n\nMit freundlichen Gr\u00fc\u00dfen',
    js_share_copied: '\u2713 Link kopiert',
    js_form_sending: 'Wird gesendet...',
    js_form_network_error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    js_status_available_title: 'In Vermarktung',
    js_wa_general: 'Guten Tag! Ich h\u00e4tte gerne vorab mehr Informationen zum Projekt am Waldrand in Oberbozen.',
    js_wa_rimmo: 'Guten Tag! Ich bin interessiert am Projekt Waldrand in Oberbozen und w\u00fcrde mich gerne f\u00fcr mehr Informationen melden. Wann w\u00e4re ein guter Zeitpunkt f\u00fcr ein kurzes Gespr\u00e4ch?',
    js_wa_footer_cta: 'Ciao! Ich will kaufen! Am liebsten sofort und am besten gleich alle 11 Wohnungen auf einmal... Wann k\u00f6nnen wir reden?',
    js_wa_unit_inquiry: 'Guten Tag, ich interessiere mich f\u00fcr Einheit \u201e{unit}\u201c im Projekt \u201eWaldrand Oberbozen\u201c. Bitte senden Sie mir mehr Informationen zu.',
    js_wa_or_via: 'Oder direkt via',
    js_recaptcha_privacy: 'Datenschutzerkl\u00e4rung',
    js_recaptcha_terms: 'Nutzungsbedingungen',
    js_recaptcha_note: 'Diese Website ist durch reCAPTCHA gesch\u00fctzt. Es gelten die',
    js_recaptcha_and: 'und',
    js_recaptcha_of: 'von Google.',

    // UNIT INQUIRY FORM
    inquiry_form_title: 'Anfrage zu Einheit',
    inquiry_form_subtitle: 'Füllen Sie das Formular aus – wir melden uns umgehend bei Ihnen.',
    inquiry_form_name: 'Vor- und Nachname *',
    inquiry_form_email: 'E-Mail Adresse *',
    inquiry_form_phone: 'Telefonnummer',
    inquiry_form_message: 'Ihre Nachricht (optional)',
    inquiry_form_submit: 'Anfrage absenden',
    inquiry_form_sending: 'Wird gesendet...',
    inquiry_form_success: 'Vielen Dank! Ihre Anfrage wurde erfolgreich übermittelt. Wir melden uns in Kürze bei Ihnen.',
    inquiry_form_error: 'Es gab ein Problem. Bitte versuchen Sie es erneut oder kontaktieren Sie uns per WhatsApp.',
    inquiry_form_back: 'Zurück',

    // STICKY CTA BAR
    sticky_cta_text: 'Interesse an einer Wohnung am Waldrand?',
    sticky_cta_btn: 'Jetzt Exposé anfordern',
    sticky_cta_btn_short: 'Exposé anfordern',
    sticky_cta_close: 'Schließen',

    // URGENCY BANNER
    urgency_text: 'Nur noch wenige Einheiten verfügbar.',
    urgency_cta: 'Jetzt Exposé sichern',

    // WHATSAPP FAB
    wa_fab_tooltip: 'Jetzt anfragen',
    wa_fab_label: 'WhatsApp',

    // EXIT INTENT MODAL
    exit_modal_eyebrow: 'Bevor Sie gehen',
    exit_modal_title: 'Kostenloses Exposé sichern',
    exit_modal_text: 'Erhalten Sie unverbindlich das vollständige Exposé mit Grundrissen, Preisliste und Details zu allen 11 Einheiten.',
    exit_modal_cta: 'Exposé anfordern',
    exit_modal_close: 'Nein danke',

    // UNIT CARDS (mobile)
    unit_card_floor: 'Etage',
    unit_card_rooms: 'Zimmer',
    unit_card_area: 'Fläche',
    unit_card_price: 'Preis',
    unit_card_details: 'Details',
  },

  it: {
    // PAGE META
    page_title: 'Vivere ai margini del bosco – Appartamenti esclusivi a Soprabolzano sul Renon | TRES IMMO',
    page_description: '11 appartamenti e case vacanza esclusivi a Soprabolzano sul Renon, Alto Adige. Vivere nella natura con vista panoramica sulle Dolomiti. Contatti TRES IMMO.',
    og_title: 'Vivere ai margini del bosco – Appartamenti esclusivi a Soprabolzano',
    og_description: '11 appartamenti esclusivi a Soprabolzano, Alto Adige. Vista sulle Dolomiti, bosco, standard KlimaHaus.',

    // HERO
    hero_location: 'Soprabolzano · Renon · Alto Adige',
    hero_tagline: 'Vivere ai margini del bosco',
    hero_sub: 'Soprabolzano &nbsp;·&nbsp; Renon &nbsp;·&nbsp; Alto Adige',
    hero_scroll: 'Scoprire',
    hero_cta_units: 'Unità disponibili',
    hero_cta_expose: 'Richiedi prospetto',
    bf_banner_text: 'Avanzamento lavori: Il solaio sopra il garage è stato gettato! Al diario di cantiere →',
    form_newsletter_label: 'Desidero ricevere aggiornamenti sull\'avanzamento dei lavori via e-mail.',
    urgency_only_few_left: 'Solo {count} unità disponibili!',

    // PROJEKT SECTION
    projekt_label: 'Il Progetto',
    projekt_headline: 'Dove il bosco<br />incontra il <em>silenzio</em>.',
    projekt_text: 'Nel cuore di Soprabolzano sul Renon nasce una residenza esclusiva con una meravigliosa vista sul panorama montano. Materiali naturali, architettura senza tempo e quiete alpina – creata da un giovane team di costruttori dell\'ensolarato Alto Adige. Chi cerca un appartamento da acquistare a Soprabolzano troverà qui un progetto che non lascia nulla a desiderare.',

    // CARDS
    card1_label: 'Appartamenti Esclusivi',
    card1_desc: 'Da accoglienti appartamenti bilocali fino a spaziose unità penthouse.',
    card2_label: 'Metri sul Livello del Mare',
    card2_desc: 'Acquistare casa sul Renon: aria di montagna fresca, vicinanza al bosco e panorama alpino a 1200m di altitudine.',
    card3_label: 'Momenti di Quiete',
    card3_desc: 'Direttamente al margine del bosco, vicino alla natura. Vicino a tutto ciò che conta.',
    card4_desc: 'Libero da vincoli – utilizzabile senza restrizioni come appartamento vacanze.',

    // RIMMO NOTE
    rimmo_text: 'Vendita esclusiva tramite <a class="rimmo-link" href="https://rimmo.it/" target="_blank" rel="noopener"><strong>Rimmo Immobilien</strong></a>',
    rimmo_wa_btn: 'Informazioni',

    // VISUALISIERUNGEN SECTION
    viz_label: 'Impressioni',
    viz_headline: 'Vivere al <em>Massimo</em> Livello.',
    viz_caption1: 'Architettura',
    viz_caption2: 'Comfort Abitativo',
    viz_caption3: 'Vista Panoramica',
    viz_caption4: 'Appartamento Vacanze I',
    viz_caption5: 'Appartamento Vacanze II',
    viz_caption6: 'Appartamento Vacanze III',
    viz_note: 'Visualizzazioni esemplificative',

    // LAGE SECTION
    lage_label: 'Posizione',
    lage_headline: 'Così <em>vicini</em><br />al cielo.',
    lage_item1_title: 'In 12 Minuti nel Centro',
    lage_item1_text: 'Sfugga al trambusto e al caldo estivo della conca di Bolzano. La Rittner Seilbahn La porta in soli 12 minuti dalla quiete al margine del bosco direttamente nel centro storico di Bolzano.',
    lage_item2_title: 'Il Rittner Bahnl & le Piste da Sci',
    lage_item2_text: 'Lo storico treno a scartamento ridotto collega Oberbozen con Collalbo. Da lì, le aree sciistiche e le zone escursionistiche attorno al Corno del Renon sono a portata di mano.',
    lage_item3_title: 'Natura dalla Porta di Casa',
    lage_item3_text: 'Situato direttamente al margine del bosco, i sentieri escursionistici e passeggiata iniziano letteralmente davanti alla Sua porta. Un perfetto equilibrio tra isolamento e infrastruttura locale (ristorazione, farmacia, supermercato). Vivere sul Renon – qui si vive con la natura, non accanto ad essa.',

    // AUSSTATTUNG SECTION
    ausstattung_label: 'Qualità',
    ausstattung_headline: 'Senza <em>Compromessi</em>.',
    ausstattung_item1_title: 'Standard KlimaHaus',
    ausstattung_item1_text: 'Costruzione modernissima combinata con un sofisticato concetto energetico. Massima efficienza, minori costi energetici e comfort abitativo sostenibile, adatto al clima alpino.',
    ausstattung_item2_title: 'Terrazze Panoramiche & Giardini',
    ausstattung_item2_text: 'Ampie vetrate dal pavimento al soffitto aprono lo spazio abitativo alla natura. Generosi giardini privati al piano terra e ampie terrazze negli appartamenti invitano a godere del panorama montano.',
    ausstattung_item3_title: 'Privacy & Sicurezza',
    ausstattung_item3_text: 'Piante razionali, isolamento acustico e scelta esclusiva dei materiali creano luoghi di ritiro di perfetta quiete. Inclusi posti auto in garage sotterraneo protetto per tutte le unità.',

    // EINHEITEN SECTION
    einheiten_label: 'Progetto Waldrand',
    einheiten_headline: 'Unità <em>Disponibili</em>',
    table_loading: 'Caricamento unità...',
    table_col_unit: 'Unità',
    table_col_unit_short: '#',
    table_col_floor: 'Piano',
    table_col_rooms: 'Locali',
    table_col_rooms_short: 'L',
    table_col_area: 'Superficie',
    table_col_area_short: 'm²',
    table_col_price: 'Prezzo',
    table_col_status: 'Stato',
    table_no_units: 'Nessuna unità trovata.',
    table_load_error: 'Errore nel caricamento dei dati.',
    units_note: 'Tutti i prezzi si intendono IVA esclusa: 4% per la prima casa e 10% per la seconda casa.',
    unit_on_request: 'Su Richiesta',
    unit_details_link: 'Dettagli',

    // SEO PARAGRAPH
    seo_text: 'Acquistare casa a Soprabolzano – esclusivo progetto residenziale sul Renon, Alto Adige. Solo 11 unità, disponibilità limitata.',

    // MODAL STATS LABELS
    modal_stat_floor: 'Piano',
    modal_stat_rooms: 'Locali',
    modal_stat_area: 'Superficie',
    modal_stat_price: 'Prezzo',
    modal_action_plan: 'Planimetria',
    modal_action_inquiry: 'Richiesta',
    modal_action_wa: 'WhatsApp',
    modal_action_share: 'Condividi',
    modal_expose: '📄 Scarica il Prospetto',

    // COMING SOON / KONTAKT
    coming_label: 'Contatto & Prospetto',
    coming_headline: 'Richieda ora <span class="cs-dot"></span><br />il <em>prospetto</em>.',
    coming_text: 'Si registri senza impegno per ricevere il prospetto completo con planimetrie e prezzi, e rimanere aggiornato sull\'avanzamento dei lavori.',
    form_name: 'Nome e Cognome *',
    form_email: 'Indirizzo E-Mail *',
    form_phone: 'Numero di Telefono',
    form_message: 'Il Suo Messaggio (facoltativo)',
    form_submit: 'Invia richiesta',
    form_sending: 'Invio in corso...',
    recaptcha_text: 'Questo sito è protetto da reCAPTCHA. Si applicano',
    recaptcha_privacy: 'l\'Informativa sulla Privacy',
    recaptcha_terms: 'i Termini di Servizio',
    recaptcha_of_google: 'di Google.',
    wa_or_via: 'Oppure direttamente via',
    wa_chat_btn: 'Chat WhatsApp',

    // FOOTER
    footer_logo_sub: 'Wohnen am Waldrand',
    footer_desc: 'Un giovane team di sviluppatori immobiliari dell\'ensolarato Alto Adige. Con passione per la qualità e lo stile di vita alpino.',
    footer_contact_label: 'Contatto',
    footer_wa_label: 'WhatsApp',
    footer_cta: 'Richiedi ora 🙋',
    footer_rights: '© TRES IMMO &nbsp;·&nbsp; Oberbozen, Ritten, Südtirol &nbsp;·&nbsp; Tutti i diritti riservati &nbsp;|&nbsp; <a href="#" onclick="openPrivacyModal(event)" style="color:inherit; text-decoration:underline;">Privacy &amp; Impressum</a>',

    // COOKIE BANNER
    cookie_header: 'Privacy & Cookie',
    cookie_text_short: 'Utilizziamo i cookie per il funzionamento e statistiche anonime. <a href="#" onclick="openPrivacyModal(event)">Informazioni</a>',
    cookie_text: 'Utilizziamo i cookie per offrirLe un\'esperienza ottimale del sito. Ciò include cookie necessari per il funzionamento del sito, nonché cookie per scopi statistici anonimi o l\'integrazione di servizi esterni (come <strong>reCAPTCHA</strong> per il nostro modulo). Ulteriori informazioni sono disponibili nella nostra <a href="#" onclick="openPrivacyModal(event)">Informativa sulla Privacy</a>.',
    cookie_essential: 'Solo Necessari',
    cookie_accept: 'Accetta Tutti',

    // PRIVACY MODAL
    privacy_title: 'Privacy & Impressum',

    // JS STRINGS
    js_floor_basement: 'PI',
    js_floor_ground: 'PT',
    js_floor_upper: '° P',
    js_rooms_suffix: ' loc.',
    js_wa_greeting: 'Buongiorno, sono interessato/a all\'unità \u201e',
    js_wa_project_in: '\u201c del progetto \u201e',
    js_wa_project_close: '\u201c. La prego di inviarmi maggiori informazioni.',
    js_email_subject_prefix: 'Richiesta ',
    js_email_subject_dash: ' \u2013 ',
    js_email_body_intro: 'Buongiorno,\n\nSono interessato/a all\'unit\u00e0 ',
    js_email_body_in: ' del progetto ',
    js_email_body_close: '.\nLa prego di inviarmi maggiori informazioni.\n\nCordiali saluti',
    js_share_copied: '\u2713 Link copiato',
    js_form_sending: 'Invio in corso...',
    js_form_network_error: 'Si è verificato un errore imprevisto. La preghiamo di riprovare più tardi.',
    js_status_available_title: 'Disponibile',
    js_wa_general: 'Buongiorno! Gradirei ricevere in anticipo maggiori informazioni sul progetto Waldrand a Soprabolzano.',
    js_wa_rimmo: 'Buongiorno! Sono interessato/a al progetto Waldrand a Soprabolzano e vorrei mettermi in contatto per maggiori informazioni. Quando sarebbe un buon momento per una breve conversazione?',
    js_wa_footer_cta: 'Ciao! Voglio acquistare! Preferibilmente subito e meglio ancora tutti e 11 gli appartamenti insieme... Quando possiamo parlare?',
    js_wa_unit_inquiry: 'Buongiorno, sono interessato/a all\'unit\u00e0 \u201e{unit}\u201c del progetto \u201eWaldrand Oberbozen\u201c. La prego di inviarmi maggiori informazioni.',
    js_wa_or_via: 'O direttamente via',
    js_recaptcha_privacy: 'Informativa sulla privacy',
    js_recaptcha_terms: 'Termini di servizio',
    js_recaptcha_note: 'Questo sito è protetto da reCAPTCHA. Si applicano la',
    js_recaptcha_and: 'e i',
    js_recaptcha_of: 'di Google.',

    // UNIT INQUIRY FORM
    inquiry_form_title: 'Richiesta per unità',
    inquiry_form_subtitle: 'Compilate il modulo – vi contatteremo al più presto.',
    inquiry_form_name: 'Nome e Cognome *',
    inquiry_form_email: 'Indirizzo E-Mail *',
    inquiry_form_phone: 'Numero di Telefono',
    inquiry_form_message: 'Il Suo Messaggio (facoltativo)',
    inquiry_form_submit: 'Invia richiesta',
    inquiry_form_sending: 'Invio in corso...',
    inquiry_form_success: 'Grazie! La Sua richiesta è stata inviata con successo. La contatteremo al più presto.',
    inquiry_form_error: 'Si è verificato un errore. Riprovi o ci contatti via WhatsApp.',
    inquiry_form_back: 'Indietro',

    // STICKY CTA BAR
    sticky_cta_text: 'Interessato a un appartamento ai margini del bosco?',
    sticky_cta_btn: 'Richiedi il prospetto',
    sticky_cta_btn_short: 'Richiedi prospetto',
    sticky_cta_close: 'Chiudi',

    // URGENCY BANNER
    urgency_text: 'Ultime unità disponibili.',
    urgency_cta: 'Richiedi il prospetto',

    // WHATSAPP FAB
    wa_fab_tooltip: 'Contattaci subito',
    wa_fab_label: 'WhatsApp',

    // EXIT INTENT MODAL
    exit_modal_eyebrow: 'Prima di andare',
    exit_modal_title: 'Ricevi il prospetto gratuito',
    exit_modal_text: 'Ottieni senza impegno il prospetto completo con planimetrie, listino prezzi e dettagli di tutte le 11 unità.',
    exit_modal_cta: 'Richiedi il prospetto',
    exit_modal_close: 'No grazie',

    // UNIT CARDS (mobile)
    unit_card_floor: 'Piano',
    unit_card_rooms: 'Stanze',
    unit_card_area: 'Superficie',
    unit_card_price: 'Prezzo',
    unit_card_details: 'Dettagli',
  },

  en: {
    // PAGE META
    page_title: 'Forest Living – Exclusive Apartments in Oberbozen on the Ritten | TRES IMMO',
    page_description: '11 exclusive apartments and holiday homes in Oberbozen on the Ritten plateau, South Tyrol. Alpine living at the forest\'s edge with panoramic Dolomite views. Contact TRES IMMO.',
    og_title: 'Forest Living – Exclusive Apartments in Oberbozen on the Ritten',
    og_description: '11 exclusive apartments in Oberbozen, South Tyrol. Dolomite views, forest setting, KlimaHaus energy standard.',

    // HERO
    hero_location: 'Oberbozen · Ritten · South Tyrol',
    hero_tagline: 'Living at the Forest\'s Edge',
    hero_sub: 'Oberbozen &nbsp;·&nbsp; Ritten &nbsp;·&nbsp; South Tyrol',
    hero_scroll: 'Discover',
    hero_cta_units: 'Available units',
    hero_cta_expose: 'Request exposé',
    bf_banner_text: 'Construction progress: The garage ceiling is concreted! View progress →',
    form_newsletter_label: 'I would like to receive updates on construction progress via email.',
    urgency_only_few_left: 'Only {count} units remaining!',

    // PROJEKT SECTION
    projekt_label: 'The Project',
    projekt_headline: 'Where the forest<br />meets <em>stillness</em>.',
    projekt_text: 'In the heart of Oberbozen on the Ritten, an exclusive residential development is taking shape with magnificent views of the mountain panorama. Natural materials, timeless architecture and alpine tranquillity – created by a young developer team from sun-drenched South Tyrol. Those seeking a property in Oberbozen will find here a project that leaves nothing to be desired.',

    // CARDS
    card1_label: 'Exclusive Apartments',
    card1_desc: 'From cosy two-room apartments to generous penthouse residences.',
    card2_label: 'Metres Above Sea Level',
    card2_desc: 'Buy property on the Ritten: fresh mountain air, forest proximity and alpine panorama at 1,200m altitude.',
    card3_label: 'Moments of Serenity',
    card3_desc: 'Directly at the forest\'s edge, close to nature. Near everything that matters.',
    card4_desc: 'Free from restrictions – available without limitation as a holiday residence.',

    // RIMMO NOTE
    rimmo_text: 'Exclusive sales through <a class="rimmo-link" href="https://rimmo.it/" target="_blank" rel="noopener"><strong>Rimmo Immobilien</strong></a>',
    rimmo_wa_btn: 'Enquire',

    // VISUALISIERUNGEN SECTION
    viz_label: 'Impressions',
    viz_headline: 'Living at the <em>Highest</em> Standard.',
    viz_caption1: 'Architecture',
    viz_caption2: 'Living Comfort',
    viz_caption3: 'Panoramic View',
    viz_caption4: 'Holiday Apartment I',
    viz_caption5: 'Holiday Apartment II',
    viz_caption6: 'Holiday Apartment III',
    viz_note: 'Illustrative visualisations',

    // LAGE SECTION
    lage_label: 'Location',
    lage_headline: 'So <em>close</em><br />to heaven.',
    lage_item1_title: 'Into the Centre in 12 Minutes',
    lage_item1_text: 'Escape the bustle and summer heat of the Bolzano basin. The Rittner Seilbahn takes you in just 12 minutes from the tranquillity of the forest\'s edge directly into the historic centre of Bolzano.',
    lage_item2_title: 'The Rittner Bahnl & Ski Area',
    lage_item2_text: 'The historic narrow-gauge railway connects Oberbozen with Klobenstein. From there, the ski and hiking areas around the Rittner Horn are within easy reach.',
    lage_item3_title: 'Nature from Your Doorstep',
    lage_item3_text: 'Situated directly at the forest\'s edge, hiking and walking paths begin literally at your door. A perfect balance of seclusion and village infrastructure (restaurants, pharmacy, supermarket). Buying property on the Ritten – here one lives with nature, not beside it.',

    // AUSSTATTUNG SECTION
    ausstattung_label: 'Quality',
    ausstattung_headline: 'Without <em>Compromise</em>.',
    ausstattung_item1_title: 'KlimaHaus Standard',
    ausstattung_item1_text: 'State-of-the-art construction combined with a sophisticated energy concept. Maximum efficiency, minimal energy costs and sustainable living comfort tailored to the alpine climate.',
    ausstattung_item2_title: 'Panoramic Terraces & Gardens',
    ausstattung_item2_text: 'Wide, floor-to-ceiling window facades open the living space to nature. Generous private gardens on the ground floor and spacious terraces on the apartments invite you to enjoy the mountain panorama.',
    ausstattung_item3_title: 'Privacy & Security',
    ausstattung_item3_text: 'Well-conceived floor plans, acoustic decoupling and an exclusive choice of materials create retreats of perfect tranquillity. Including protected underground parking spaces for all units.',

    // EINHEITEN SECTION
    einheiten_label: 'Project Waldrand',
    einheiten_headline: 'Available <em>Units</em>',
    table_loading: 'Loading units...',
    table_col_unit: 'Unit',
    table_col_unit_short: '#',
    table_col_floor: 'Floor',
    table_col_rooms: 'Rooms',
    table_col_rooms_short: 'R',
    table_col_area: 'Living Area',
    table_col_area_short: 'm²',
    table_col_price: 'Price',
    table_col_status: 'Status',
    table_no_units: 'No units found.',
    table_load_error: 'Error loading data.',
    units_note: 'All prices are exclusive of VAT: 4% for primary residence and 10% for secondary residence.',
    unit_on_request: 'Upon Request',
    unit_details_link: 'Details',

    // SEO PARAGRAPH
    seo_text: 'Buy property in Oberbozen – exclusive residential project on the Ritten, South Tyrol. Only 11 units, limited availability.',

    // MODAL STATS LABELS
    modal_stat_floor: 'Floor',
    modal_stat_rooms: 'Rooms',
    modal_stat_area: 'Area',
    modal_stat_price: 'Price',
    modal_action_plan: 'Plan',
    modal_action_inquiry: 'Enquire',
    modal_action_wa: 'WhatsApp',
    modal_action_share: 'Share',
    modal_expose: '📄 Download Exposé',

    // COMING SOON / KONTAKT
    coming_label: 'Contact & Exposé',
    coming_headline: 'Request your <span class="cs-dot"></span><br />exclusive <em>exposé</em>.',
    coming_text: 'Register without obligation to receive the full exposé with floor plans and pricing, and stay updated on the construction progress.',
    form_name: 'First and Last Name *',
    form_email: 'E-Mail Address *',
    form_phone: 'Phone Number',
    form_message: 'Your Message (optional)',
    form_submit: 'Enquire now',
    form_sending: 'Sending...',
    recaptcha_text: 'This site is protected by reCAPTCHA. Google\'s',
    recaptcha_privacy: 'Privacy Policy',
    recaptcha_terms: 'Terms of Service',
    recaptcha_of_google: 'apply.',
    wa_or_via: 'Or directly via',
    wa_chat_btn: 'WhatsApp Chat',

    // FOOTER
    footer_logo_sub: 'Wohnen am Waldrand',
    footer_desc: 'A young real estate development team from sun-drenched South Tyrol. With a passion for quality and alpine living.',
    footer_contact_label: 'Contact',
    footer_wa_label: 'WhatsApp',
    footer_cta: 'Enquire now 🙋',
    footer_rights: '© TRES IMMO &nbsp;·&nbsp; Oberbozen, Ritten, Südtirol &nbsp;·&nbsp; All rights reserved &nbsp;|&nbsp; <a href="#" onclick="openPrivacyModal(event)" style="color:inherit; text-decoration:underline;">Privacy &amp; Imprint</a>',

    // COOKIE BANNER
    cookie_header: 'Privacy & Cookies',
    cookie_text_short: 'We use cookies for operation and anonymous statistics. <a href="#" onclick="openPrivacyModal(event)">More info</a>',
    cookie_text: 'We use cookies to provide you with an optimal website experience. This includes cookies necessary for the operation of the site, as well as cookies for anonymous statistical purposes or the integration of external services (such as <strong>reCAPTCHA</strong> for our form). Further information can be found in our <a href="#" onclick="openPrivacyModal(event)">Privacy Policy</a>.',
    cookie_essential: 'Essential Only',
    cookie_accept: 'Accept All',

    // PRIVACY MODAL
    privacy_title: 'Privacy & Imprint',

    // JS STRINGS
    js_floor_basement: 'B1',
    js_floor_ground: 'GF',
    js_floor_upper: 'F',
    js_rooms_suffix: ' rm.',
    js_wa_greeting: 'Good day, I am interested in unit \u201e',
    js_wa_project_in: '\u201c in the project \u201e',
    js_wa_project_close: '\u201c. Please send me further information.',
    js_email_subject_prefix: 'Enquiry ',
    js_email_subject_dash: ' \u2013 ',
    js_email_body_intro: 'Good day,\n\nI am interested in unit ',
    js_email_body_in: ' in the project ',
    js_email_body_close: '.\nPlease send me further information.\n\nKind regards',
    js_share_copied: '\u2713 Link copied',
    js_form_sending: 'Sending...',
    js_form_network_error: 'An unexpected error occurred. Please try again later.',
    js_status_available_title: 'Available',
    js_wa_general: 'Good day! I would like to receive advance information about the Waldrand project in Oberbozen.',
    js_wa_rimmo: 'Good day! I am interested in the Waldrand project in Oberbozen and would like to get in touch for further information. When would be a good time for a brief conversation?',
    js_wa_footer_cta: 'Hello! I would like to purchase! Ideally right away and preferably all 11 apartments at once... When can we speak?',
    js_wa_unit_inquiry: 'Good day, I am interested in unit \u201e{unit}\u201c of the project \u201eWaldrand Oberbozen\u201c. Please send me further information.',
    js_wa_or_via: 'Or directly via',
    js_recaptcha_privacy: 'Privacy Policy',
    js_recaptcha_terms: 'Terms of Service',
    js_recaptcha_note: 'This site is protected by reCAPTCHA. The',
    js_recaptcha_and: 'and',
    js_recaptcha_of: 'of Google apply.',

    // UNIT INQUIRY FORM
    inquiry_form_title: 'Enquiry for unit',
    inquiry_form_subtitle: 'Fill out the form – we will get back to you promptly.',
    inquiry_form_name: 'First and Last Name *',
    inquiry_form_email: 'E-Mail Address *',
    inquiry_form_phone: 'Phone Number',
    inquiry_form_message: 'Your Message (optional)',
    inquiry_form_submit: 'Send enquiry',
    inquiry_form_sending: 'Sending...',
    inquiry_form_success: 'Thank you! Your enquiry has been submitted successfully. We will contact you shortly.',
    inquiry_form_error: 'Something went wrong. Please try again or contact us via WhatsApp.',
    inquiry_form_back: 'Back',

    // STICKY CTA BAR
    sticky_cta_text: 'Interested in an apartment at the forest\'s edge?',
    sticky_cta_btn: 'Request exposé now',
    sticky_cta_btn_short: 'Request exposé',
    sticky_cta_close: 'Close',

    // URGENCY BANNER
    urgency_text: 'Only a few units remaining.',
    urgency_cta: 'Request exposé now',

    // WHATSAPP FAB
    wa_fab_tooltip: 'Contact us now',
    wa_fab_label: 'WhatsApp',

    // EXIT INTENT MODAL
    exit_modal_eyebrow: 'Before you leave',
    exit_modal_title: 'Get the free exposé',
    exit_modal_text: 'Receive the full exposé with floor plans, price list and details for all 11 units – free and without obligation.',
    exit_modal_cta: 'Request exposé',
    exit_modal_close: 'No thanks',

    // UNIT CARDS (mobile)
    unit_card_floor: 'Floor',
    unit_card_rooms: 'Rooms',
    unit_card_area: 'Area',
    unit_card_price: 'Price',
    unit_card_details: 'Details',
  }
};
